export interface IWsProductoCart {
    IdArticulo: number;
    CodCipsa: string;
    Nombre: string;
    UM: string;
    IdMoneda: string;
    Moneda: string;
    Precio: number;
    NombreComercial: string;
    IdLinea: string;
    Linea: string;
    IdGrupo: string;
    Grupo: string;
    IdTipo: string;
    Tipo: string;
    IdFamilia: string;
    Familia: string;
}

export class WsProductoCart {
    IdArticulo: number;
    CodCipsa: string;
    Nombre: string;
    UM: string;
    IdMoneda: string;
    Moneda: string;
    Precio: number;
    NombreComercial: string;
    IdLinea: string;
    Linea: string;
    IdGrupo: string;
    Grupo: string;
    IdTipo: string;
    Tipo: string;
    IdFamilia: string;
    Familia: string;

    constructor(data?: IWsProductoCart) {
        if (data) {
            this.IdArticulo = data.IdArticulo;
            this.CodCipsa = data.CodCipsa;
            this.Nombre = data.Nombre;
            this.UM = data.UM;
            this.IdMoneda = data.IdMoneda;
            this.Moneda = data.Moneda;
            this.Precio = data.Precio;
            this.NombreComercial = data.NombreComercial;
            this.IdLinea = data.IdLinea;
            this.Linea = data.Linea;
            this.IdGrupo = data.IdGrupo;
            this.Grupo = data.Grupo;
            this.IdTipo = data.IdTipo;
            this.Tipo = data.Tipo;
            this.IdFamilia = data.IdFamilia;
            this.Familia = data.Familia;
        }
    }
}

export interface IProductoCartClasificacion {
    Id: string;
    Detalle: string;
}

// Ficha del artículo completa
export interface IWsProductoCartResult {
    Articulo: {
        IdArticulo: number,
        CodCipsa: string,
        Nombre: string,
        UM: string,
        IdMoneda: string,
        Moneda: string,
        PrecioWeb: number,
        DescripcionComercial: string,
        IdLinea: string,
        Linea: string,
        IdGrupo: string,
        Grupo: string,
        IdTipo: string,
        Tipo: string,
        IdFamilia: string,
        Familia: string,
        IdNivel1: string,
        IdNivel2: string,
        IdNivel3: string,
        IdNivel4: string,
        IdNivel5: string,
        IdNivel6: string,
        Nivel1: string,
        Nivel2: string,
        Nivel3: string,
        Nivel4: string,
        Nivel5: string,
        Nivel6: string,
        Resumen: string,
        PrecioWebCondiciones: string,
        Caracteristicas: string
    };

    UnidadesMedida: [];
    Especificaciones: [];
    Aplicaciones: [];
    Complementos: [];
    Alternativos: [];
    Kit: [];
    Galeria: [];
    Archivos: [];
    Comentarios: [];
    Stock: any;
}

export class WsProductoCartResult {
    IdArticulo: number;
    CodCipsa: string;
    Nombre: string;
    UM: string;
    IdMoneda: string;
    Moneda: string;
    PrecioWeb: number;
    DescripcionComercial: string;
    IdLinea: string;
    Linea: string;
    IdGrupo: string;
    Grupo: string;
    IdTipo: string;
    Tipo: string;
    IdFamilia: string;
    Familia: string;
    IdNivel1: string;
    IdNivel2: string;
    IdNivel3: string;
    IdNivel4: string;
    IdNivel5: string;
    IdNivel6: string;
    Nivel1: string;
    Nivel2: string;
    Nivel3: string;
    Nivel4: string;
    Nivel5: string;
    Nivel6: string;
    Resumen: string;
    PrecioWebCondiciones: string;

    UnidadesMedida = [];
    Caracteristicas: string;
    Especificaciones = [];
    Aplicaciones = [];
    Complementos = [];
    Alternativos = [];
    Kit = [];
    Galeria = [];
    Archivos = [];
    Comentarios = [];
    Stock: any;

    constructor(data?: IWsProductoCartResult) {
        if (data) {
            if (data.Articulo) {
                this.IdArticulo = data.Articulo.IdArticulo;
                this.CodCipsa = data.Articulo.CodCipsa;
                this.Nombre = data.Articulo.Nombre;
                this.UM = data.Articulo.UM;
                this.IdMoneda = data.Articulo.IdMoneda;
                this.Moneda = data.Articulo.Moneda;
                this.PrecioWeb = data.Articulo.PrecioWeb || 0;
                this.DescripcionComercial = data.Articulo.DescripcionComercial;
                this.IdLinea = data.Articulo.IdLinea;
                this.Linea = data.Articulo.Linea;
                this.IdGrupo = data.Articulo.IdGrupo;
                this.Grupo = data.Articulo.Grupo;
                this.IdTipo = data.Articulo.IdTipo;
                this.Tipo = data.Articulo.Tipo;
                this.IdFamilia = data.Articulo.IdFamilia;
                this.Familia = data.Articulo.Familia;
                this.IdNivel1 = data.Articulo.IdNivel1;
                this.IdNivel2 = data.Articulo.IdNivel2;
                this.IdNivel3 = data.Articulo.IdNivel3;
                this.IdNivel4 = data.Articulo.IdNivel4;
                this.IdNivel5 = data.Articulo.IdNivel5;
                this.IdNivel6 = data.Articulo.IdNivel6;
                this.Nivel1 = data.Articulo.Nivel1;
                this.Nivel2 = data.Articulo.Nivel2;
                this.Nivel3 = data.Articulo.Nivel3;
                this.Nivel4 = data.Articulo.Nivel4;
                this.Nivel5 = data.Articulo.Nivel5;
                this.Nivel6 = data.Articulo.Nivel6;
                this.Resumen = data.Articulo.Resumen;
                this.PrecioWebCondiciones = data.Articulo.PrecioWebCondiciones;
                this.Caracteristicas = data.Articulo.Caracteristicas;
            }

            this.UnidadesMedida = (data.UnidadesMedida || []).filter((x: any) => x.FlagVentaWeb);
            this.Especificaciones = data.Especificaciones || [];
            this.Aplicaciones = data.Aplicaciones || [];
            this.Complementos = data.Complementos || [];
            this.Alternativos = data.Alternativos || [];
            this.Kit = data.Kit || [];
            this.Galeria = data.Galeria || [];
            this.Archivos = data.Archivos || [];
            this.Comentarios = data.Comentarios || [];

            // Para este aplicativo solo consideraremos el stock del 0141 - ALMACEN CIPTECH
            // const stock = data.Stock.find(x => x.ID_ALMACEN === '0141');

            //Se esta cambiando temporalmente que se va a considerar el stock de almacen CIPTECH VIRTUAl
            const stock = data.Stock.find(x => x.ID_ALMACEN === '01VC');

            // const stock = {
            //     STOCK_DISPONIBLE: data.Stock.filter(x => x.FLG_VENTA).map(x => x.STOCK_DISPONIBLE).reduce(((a, b) => a + b), 0),
            //     UNIDAD_MEDIDA: (data.Stock[0] || {}).UNIDAD_MEDIDA
            // };

            this.Stock = stock;
        }
    }
}
